const CTBIcon = ({ className }: { className?: string }) => (
  <svg
    width="150"
    height="90"
    viewBox="-10 0 150 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={className}
  >
    <image
      id="image0_1_257"
      width="140"
      height="50"
      x="-10"
      y="20"
      xlinkHref="/ctb_logo_1.png"
    />
  </svg>
);

export default CTBIcon;
